// @flow

import React, {Component, Fragment} from 'react';
import debounce from 'lodash.debounce';
import {shouldUpdate} from '@pb/kit-util-should-update';

import {ScrollableArrow} from './scrollable-arrow';
import NavigationArrows from './navigation-arrows';
import {ArrowDirection, ARROW_SCROLLING_TIME} from './constants';

import type {ScrollArrowsData, OnArrowScroll} from './typedef';


const HorizontalDirection = {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    NONE: 'NONE'
};
type HorizontalDirectionType = $Keys<typeof HorizontalDirection>;


type Props = {|
    parent: HTMLDivElement | null,

    isLeftArrow: boolean,
    isRightArrow: boolean,
    shift: number,
    contentSize: number,
    containerSize: number,

    scrollArrows: ScrollArrowsData,
    onArrowScroll: OnArrowScroll,
|};
type State = {|
    scrollDirection: HorizontalDirectionType,
|};


export class ScrollArrows extends Component<Props, State> {
    navigationArrows: NavigationArrows;
    endScrolling: () => void;

    constructor(props: Props) {
        super(props);
        this.state = {
            scrollDirection: HorizontalDirection.NONE
        };

        const {scrollArrows: {delta}, onArrowScroll, shift, contentSize} = props;
        this.navigationArrows = new NavigationArrows({delta, onArrowScroll, leftShift: shift});
        this.navigationArrows.setContentWidth(contentSize);
        this.endScrolling = debounce(this._endScrolling, ARROW_SCROLLING_TIME);
    }

    componentDidUpdate(prevProps: Props) {
        if (shouldUpdate(this.props, prevProps, ['shift'])) {
            const {shift} = this.props;
            this.navigationArrows.setLeftShift(shift);
            this.setState({
                scrollDirection: shift > prevProps.shift ? HorizontalDirection.LEFT : HorizontalDirection.RIGHT
            });
            this.endScrolling();
        }
        if (shouldUpdate(this.props, prevProps, ['contentSize'])) {
            const {contentSize} = this.props;
            this.navigationArrows.setContentWidth(contentSize);
        }
        if (shouldUpdate(this.props, prevProps, ['containerSize'])) {
            const {containerSize} = this.props;
            this.navigationArrows.setContainerWidth(containerSize);
        }
        if (shouldUpdate(this.props.scrollArrows, prevProps.scrollArrows, ['delta'])) {
            const {scrollArrows} = this.props;
            this.navigationArrows.setDelta(scrollArrows.delta);
        }
    }

    _endScrolling = () => {
        this.setState({
            scrollDirection: HorizontalDirection.NONE
        });
    };

    onLeftArrowClick = () => {
        if (this.props.scrollArrows.onArrowClick) {
            this.props.scrollArrows.onArrowClick();
        }
        this.navigationArrows.clickArrow(ArrowDirection.LEFT);

    };

    onRightArrowClick = () => {
        if (this.props.scrollArrows.onArrowClick) {
            this.props.scrollArrows.onArrowClick();
        }
        this.navigationArrows.clickArrow(ArrowDirection.RIGHT);
    };

    render() {
        const {
            isLeftArrow,
            isRightArrow,
            parent,
            scrollArrows: {headerClasses, customScrollable, navClasses, navigationContainer}
        } = this.props;
        const {scrollDirection} = this.state;

        return (
            <Fragment>
                {isLeftArrow ? (
                    <ScrollableArrow
                        onClick={this.onLeftArrowClick}
                        activeScroll={scrollDirection === HorizontalDirection.LEFT}
                        direction={ArrowDirection.LEFT}
                        parent={parent}
                        {...{headerClasses, customScrollable, navClasses, navigationContainer}}
                    />
                ) : null}
                {isRightArrow ? (
                    <ScrollableArrow
                        onClick={this.onRightArrowClick}
                        activeScroll={scrollDirection === HorizontalDirection.RIGHT}
                        direction={ArrowDirection.RIGHT}
                        parent={parent}
                        {...{headerClasses, customScrollable, navClasses, navigationContainer}}
                    />
                ) : null}
            </Fragment>
        );
    }
}
